import { createSelector } from "reselect";

import { RootState } from "../../store/types";
import { PortfolioCategory, Portfolio } from "../../models";

const portfolio = (state: RootState) => state.portfolioCarousel;

export const categories = createSelector(portfolio, state =>
  Object.values<PortfolioCategory>(state.categories),
);

export const activeCategory = createSelector(
  portfolio,
  state => state.chosenCategory,
);

const portfolios = createSelector(portfolio, state => state.portfolios);

export const filteredPortfolios = createSelector(
  portfolios,
  activeCategory,
  (portfolios, id) => {
    const arr = Object.values<Portfolio>(portfolios);

    return id ? arr.filter(portfolio => portfolio.category_id === id) : arr;
  },
);



// WEBPACK FOOTER //
// ./src/routes/PortfolioCarousel/selectors.ts